import { render, staticRenderFns } from "./foodProfile.vue?vue&type=template&id=6ebe8020&scoped=true&"
import script from "./foodProfile.vue?vue&type=script&lang=js&"
export * from "./foodProfile.vue?vue&type=script&lang=js&"
import style0 from "./foodProfile.vue?vue&type=style&index=0&id=6ebe8020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebe8020",
  null
  
)

export default component.exports